@if (display) {
  <button type="button"
    [iCmsModalOpen]="cmsModalOpen"
    [iCmsModalOpenData]="product"
  class="c1 col-11 b-b button-inline-static-underline">{{'Order a Fabric Sample' | translate}}</button>
}